<template>
  <div class="container-header">
    <DateFilter
      v-if="Boolean(urlDateRange)"
      :initial-date="urlDateRange"
      @change="setDateRange"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DateFilter from '@/components/fast_intelligence/BrandHeader/DateFilter.vue';

export default {
  components: {
    DateFilter
  },
  computed: {
    ...mapState('filter', ['urlDateRange']),
  },
  methods: {
    ...mapActions('filter', ['setDateRange']),
  }
};
</script>

<style lang="scss" scoped>
@import "@/mixins/scss/_mixins.scss";

.container-header {
  position: fixed;
  padding-left: 20px;
  z-index: var(--zindex-1);
  background-color: #222;
  justify-content: flex-start;
  box-shadow: var(--ds-dark-dropshadow-1);

  @include set-size(100%, 80px);
  @include flex-center-vertically;
}
</style>
